const BASE_HEADER_HEIGHT = 90;
const PADDING_UNDER_SFA_HEADER = 16;

export const SFA_HEADER_HEIGHT = 90 + PADDING_UNDER_SFA_HEADER;
export const CANVAS_TOP_MARGIN = (sfa = false) =>
  BASE_HEADER_HEIGHT + (sfa ? SFA_HEADER_HEIGHT : 0);

// It is magic number that encapsulates the width of left toolbar (74px) and left padding (14px)
// and right padding (20px) to make fit logic behavior the same as resetScrollbars logic behavior
export const LEFT_TOOLBAR_WIDTH = 108;
